import appConfig from '../config';

export default{

	getAccessToken:function(){
		return sessionStorage.getItem(appConfig.accessTokenKey);
	},
	
	setAccessToken:function(token){
		sessionStorage.setItem(appConfig.accessTokenKey,token);
	},
	
	removeAccessToken:function(){
		sessionStorage.removeItem(appConfig.accessTokenKey);
	},
	
}